import { cn } from '@/lib/utils';
import React from 'react';

interface IconComponentProps {
  IconType: React.ElementType;
  className?: string;
}
export const IconComponent = ({ IconType, className }: IconComponentProps) => {
  className = cn('h-4 w-4', className);
  return <IconType className={className} />;
};
